var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcUser = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 160,
  height: 160,
  viewBox: "0 0 160 160",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_957",
  "data-name": "Group 957",
  transform: "translate(-657 -516)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_27",
  "data-name": "Ellipse 27",
  cx: 80,
  cy: 80,
  r: 80,
  transform: "translate(657 516)",
  fill: "#b1b1b1"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_958",
  "data-name": "Group 958"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_217",
  "data-name": "Path 217",
  transform: "translate(-1999.708 -1227.552)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2703.726,1856.534h65.963s-.019-5.924,0-8.252-9.282-17.655-33.667-17.655-32.3,15.791-32.3,18.365S2703.726,1856.534,2703.726,1856.534Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 2768.185546875 1855.03369140625 C 2768.181396484375 1853.125366210938 2768.177001953125 1849.892822265625 2768.189208984375 1848.300659179688 C 2768.152587890625 1848.067016601562 2767.775146484375 1846.946411132812 2766.444091796875 1845.13427734375 C 2765.434326171875 1843.759521484375 2763.636962890625 1841.675537109375 2760.80810546875 1839.554931640625 C 2757.8994140625 1837.374267578125 2754.55126953125 1835.639770507812 2750.857421875 1834.399780273438 C 2746.364990234375 1832.891845703125 2741.373779296875 1832.127197265625 2736.0224609375 1832.127197265625 C 2730.619140625 1832.127197265625 2725.65869140625 1832.931030273438 2721.278564453125 1834.516235351562 C 2717.692138671875 1835.814208984375 2714.5 1837.629150390625 2711.79052734375 1839.910400390625 C 2709.171630859375 1842.115478515625 2707.56689453125 1844.286254882812 2706.68212890625 1845.718872070312 C 2705.501220703125 1847.630859375 2705.233154296875 1848.787963867188 2705.22607421875 1848.988891601562 C 2705.229248046875 1850.656982421875 2705.228271484375 1853.35595703125 2705.227294921875 1855.03369140625 L 2768.185546875 1855.03369140625 M 2769.689453125 1856.53369140625 L 2703.72607421875 1856.53369140625 C 2703.72607421875 1856.53369140625 2703.73095703125 1851.56591796875 2703.72607421875 1848.99169921875 C 2703.720458984375 1846.417724609375 2711.638916015625 1830.627197265625 2736.0224609375 1830.627197265625 C 2760.406982421875 1830.627197265625 2769.708984375 1845.955078125 2769.689453125 1848.281982421875 C 2769.6708984375 1850.609375 2769.689453125 1856.53369140625 2769.689453125 1856.53369140625 Z",
  stroke: "none",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_10",
  "data-name": "Ellipse 10",
  transform: "translate(720 562)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 17,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 16.25,
  fill: "none"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_user.ae26c3db6d2500ac73587e4f74ed7fb8.svg";